import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { DataProtectionConfigService } from "./data-protection.config";

@Injectable({
	providedIn: "root",
})
export class DataProtectionService {
	constructor(
		private client: CoreHttpClient,
		private config: DataProtectionConfigService
	) {}

	getGdprEnabledCountries(): Observable<string[]> {
		return this.client.get<string[]>({
			url: this.config.getGdprEnabledCountriesEndpoint(),
		});
	}
}
